import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import { Ability } from '@casl/ability'

Vue.use(abilitiesPlugin, new Ability([
  { action: 'no-access' }
]))
